import createRequestUrl from 'api/utils/createRequestUrl';
import {
  ContractFileApiAxiosParamCreator,
  ContractFileApiFactory,
  ContractStatusEnum,
} from 'generated';
import { instanceApi } from 'utils/axios';
import forceFileDownload from 'utils/forceFileDownload';
import useRequest from './useRequest';

// Misc
const contractFileApi = ContractFileApiFactory(undefined, '', instanceApi);
const contractFileApiParamCreator = ContractFileApiAxiosParamCreator(undefined);

export const useContractDocuments = (contractId?: string, contractStatus?: ContractStatusEnum) =>
  useRequest(
    contractFileApi.contractFileGetDocuments,
    [contractId],
    {},
    contractId !== undefined && contractStatus !== undefined && contractStatus !== ContractStatusEnum.Inactive,
  );

export const downloadContractFile = async (
  contractId: string,
  fileId: string,
  fileName: string,
) => {
  const requestArgs = await contractFileApiParamCreator.contractGetFile(contractId, fileId);
  forceFileDownload(createRequestUrl(requestArgs), fileName);
};

export default contractFileApi;
